module.exports = __webpack_public_path__ + "media/images/bank_images/nossa_caixa-2cc56bc6c1a5581c5e3c0dc3ea09e6da.png";